import { useCallback, useEffect, useState } from 'react'

import QueryStringBuilder from '@ultimatemedical/uma-utils/dist/query-string/builder'
import { useDispatch, useSelector } from 'react-redux'

import { hiddenFormParamEnums } from '../enums'
import { hiddenFormParamActions } from '../redux/actions'
import { initialHiddenFormParams } from '../redux/initial-state'
import { selectHiddenFormParams } from '../redux/selectors/index'
import { hiddenFormParamTypes } from '../types'

type MergeCallback = (params: hiddenFormParamTypes.HiddenFormParam[]) => void

function useHiddenFormParams() {
  const dispatch = useDispatch()
  const [hiddenFormParams, setHiddenFormParams] = useState<hiddenFormParamTypes.Compiled[]>([])
  const globalFormParamConfig = useSelector(selectHiddenFormParams)

  useEffect(() => {
    const qsb = new QueryStringBuilder(globalFormParamConfig)
    qsb.withOverrides(window.location.search).build()
    setHiddenFormParams(qsb.getKeyValuePairs())
  }, [globalFormParamConfig])

  // Merges an array of hidden form params into state
  const mergeHiddenFormParams: MergeCallback = useCallback(
    (params: hiddenFormParamTypes.HiddenFormParam[]): void => {
      dispatch(hiddenFormParamActions.merge(params))
    }, [dispatch],
  )

  const getCompiledValue: (key: hiddenFormParamEnums.keys)
    => hiddenFormParamTypes.Compiled = useCallback((key) => {
      const found = hiddenFormParams.filter((p) => (!!p[key]))
      if (found.length) return found[0]
      return undefined
    }, [hiddenFormParams])

  // Resets hidden form params to initial values
  // Not sure we'd ever use this, but it's here
  const resetHiddenFormParams = useCallback((): void => {
    dispatch(hiddenFormParamActions.merge(initialHiddenFormParams))
  }, [dispatch])

  return {
    getCompiledValue,
    hiddenFormParams,
    mergeHiddenFormParams,
    resetHiddenFormParams,
  }
}

export default useHiddenFormParams
